import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Stack } from '@mui/material';

import { QrPreview } from './QrPreview';

export const Step3 = () => {
  const { t } = useTranslation();

  return (
    <Stack>
      <Typography variant="subtitle1Bold" gutterBottom>
        {t('stepTitle_qrCode')}
      </Typography>
      <QrPreview />
    </Stack>
  );
};
